module.exports = __webpack_public_path__ + "media/images/user-icon-021a2fed7279ff9fb7477467e05aa911066a3a5f90662cee507734c65c427f6d.svg";